import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  userAccessSideBarHeader: false,
  InnerbarDashboardAccess: false,
};

const userAccessSlice = createSlice({
  name: "userAccessSideBarHeader",

  initialState,
  reducers: {
    setIsHeaderSideBarAccess: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.userAccessSideBarHeader = payload;
    },
    resetIsHeaderSideBarAccess: (state: any) => {
      state.userAccessSideBarHeader = false;
    },
    setInnerbarDashboardAccess: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.InnerbarDashboardAccess = payload;
    },
  },
});

export const {
  setIsHeaderSideBarAccess,
  resetIsHeaderSideBarAccess,
  setInnerbarDashboardAccess,
} = userAccessSlice.actions;

export default userAccessSlice.reducer;
